import { graphql } from '@mp/graphql/generated';
import { useGraphQLQuery } from '../../../hooks/useGraphQLRequest';
import { GetProfessionalSaasDetailQuery } from '@mp/graphql/generated/graphql';

const ProfessionalSaasDetailGql = graphql(`
  query GetProfessionalSaasDetail($input: ProfessionalSaasDetailQueryInput) {
    professionalSaasDetails(input: $input) {
      active
      available_job_slot_labels
      callback_hourly_rate_cents
      company {
        id
      }
      company_id
      double_overtime_multiplier
      employment_type
      expected_weekly_hours
      float_hourly_rate_cents
      hourly_rate_cents
      id
      joined_at
      max_consecutive_days_streak
      max_consecutive_weeks_streak
      max_daily_overtime_hours
      max_daily_regular_hours
      max_weekly_hours
      max_weekly_regular_hours
      max_weekly_shifts
      offboarded_at
      offboarded_reason
      on_call_hourly_rate_cents
      overtime_multiplier
      payout_kind
      preferences_last_updated_at
      preferences_last_updated_by_account_id
      preferred_job_slots {
        id
      }
      preferred_locations {
        id
      }
      preferred_positions {
        id
      }
      preferred_weekly_hours
      preferred_weekly_total_shifts
      preferred_workdays
      professional {
        id
      }
      professional_id
      shift_types
      workday_limit
    }
  }
`);

export const useProfessionalSaasDetail = (professionalId: number | undefined) => {
  const enabled = !!professionalId;

  const { data, isLoading } = useGraphQLQuery<GetProfessionalSaasDetailQuery>({
    operationName: 'GetProfessionalSaasDetail',
    query: ProfessionalSaasDetailGql,
    enabled,
    variables: {
      input: {
        filter: { professional_id: professionalId },
      },
    },
  });

  return {
    professionalSaasDetail: data?.professionalSaasDetails?.[0],
    isLoading: enabled ? isLoading : false,
  };
};
